import React from "react";
import styled, { css } from "styled-components";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const variantStyles = {
  default: css`
    background: #ffffff;
    border: 1px solid rgb(224, 228, 244);
  `,
  ghost: css`
    background: #2125431a;
    border: 1px solid #8888881a;
    color: #64748b;
  `,
  solid: css`
    background: #212543;
    border: 1px solid #888888;
  `,
};

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 0 16px;
  height: 42px;
  transition: border-color 0.2s;

  ${(props) => variantStyles[props.variant || "default"]};

  border-color: ${(props) => (props.error ? "rgb(220, 38, 38)" : undefined)};

  &:focus-within {
    border-color: rgb(97, 98, 197);
  }
`;

const StyledInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  color: rgb(33, 37, 67);
  background: transparent;
  /* Overflow handling */
  overflow-x: auto;
  white-space: nowrap;
  text-overflow: initial;

  &::placeholder {
    color: rgb(179, 182, 195);
  }

  ${({ variant }) =>
    variant === "ghost" &&
    `
     color:  #64748B;
       &::placeholder {
    color: #64748B;
  }
  `}
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
`;
const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;

const Input = ({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  icon,
  onIconClick,
  error,
  errorMessage,
  name,
  inputStyle,
  variant = "default",
  required = false,
  ...props
}) => {
  return (
    <InputContainer>
      {label && (
        <Label>
          {label}
          {required && <Required>*</Required>}
        </Label>
      )}
      <InputWrapper variant={variant} error={error}>
        <StyledInput
          variant={variant}
          style={{
            width: "100%", // ✅ take up available space
            minWidth: 0, // ✅ allow shrinking in tight layouts
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap", // optional: keep input on one line
          }}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          {...props}
        />
        {icon && <Icon src={icon} onClick={onIconClick} alt="input icon" />}
      </InputWrapper>
      {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputContainer>
  );
};

export default Input;
